import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box, Button, Chip, Dialog, DialogActions, DialogContent, Stack, Typography,
} from '@mui/material';
import BotAvatar from './BotAvatar';

const ORIGIN = { template: 'ready-made team', owner: 'added by you', primary_bot: 'proposed by OrkaCrew' };

/** Read-only details of a team member, with shortcuts to chat with them and (for owners) to edit. */
export default function BotDetailDialog({
  bot, catalog, counts, isOwner, onClose, onEdit,
}) {
  if (!bot) return null;
  const labels = bot.permissions.map((p) => catalog.find((c) => c.action === p)?.label || p);
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
          <BotAvatar bot={bot} size={56} />
          <Box>
            <Typography variant="h6">{bot.name}</Typography>
            <Typography color="text.secondary">{bot.role}</Typography>
          </Box>
        </Stack>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          {[bot.reports_to_name ? `Reports to ${bot.reports_to_name}` : 'Top of the team', bot.is_primary ? 'built in' : ORIGIN[bot.created_by], bot.active ? null : 'inactive']
            .filter(Boolean).join(' · ')}
        </Typography>
        <Typography fontWeight={600}>Access</Typography>
        <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap sx={{ mb: 1.5, mt: 0.5 }}>
          {labels.length === 0
            ? <Chip size="small" variant="outlined" label={bot.is_primary ? 'Organises the team' : 'No access'} />
            : labels.map((l) => <Chip key={l} size="small" variant="outlined" color="primary" label={l} />)}
        </Stack>
        <Typography fontWeight={600}>Tasks</Typography>
        <Typography color="text.secondary" sx={{ mb: 1.5 }}>
          {counts?.open ? `${counts.open} open${counts.overdue ? `, ${counts.overdue} overdue` : ''}` : 'No open tasks'}
        </Typography>
        <Typography fontWeight={600}>What they do</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-wrap', maxHeight: 220, overflowY: 'auto' }}>{bot.instructions}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Close</Button>
        <Button component={RouterLink} to={`/chat?bot=${bot.id}`}>Open chat</Button>
        {isOwner && !bot.is_primary && <Button variant="contained" onClick={() => onEdit(bot)}>Edit</Button>}
      </DialogActions>
    </Dialog>
  );
}
